export {OffersLayout} from "./offers-layout";
